
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Fresnel from "../bindings/Fresnel.bs.js";
import * as Js_dict from "@rescript/std/lib/es6/js_dict.js";
import * as Constants from "../common/Constants.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as InternationalHeader from "../components/pages/international/InternationalHeader.bs.js";
import * as InternationalContentMobile from "../components/pages/international/InternationalContentMobile.bs.js";
import * as InternationalContentDesktop from "../components/pages/international/InternationalContentDesktop.bs.js";

function International(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(InternationalHeader.make, {}),
                JsxRuntime.jsx(Fresnel.Media.make, {
                      lessThan: "lg",
                      children: JsxRuntime.jsx(InternationalContentMobile.make, {})
                    }),
                JsxRuntime.jsx(Fresnel.Media.make, {
                      greaterThanOrEqual: "lg",
                      children: JsxRuntime.jsx(InternationalContentDesktop.make, {})
                    })
              ],
              className: "xl:container mx-auto px-5"
            });
}

function getServerSideProps(param) {
  if (Belt_Option.isNone(Js_dict.get(param.query, "preview"))) {
    param.res.setHeader("Cache-Control", Constants.ssr_page_cache);
  }
  return {
          props: {}
        };
}

var make = International;

var $$default = International;

export {
  make ,
  getServerSideProps ,
  $$default ,
  $$default as default,
}
/* Fresnel Not a pure module */
